import { isEmbedded } from '@webapp/common/lib/ua';

/**
 * Событие survey для кастомных интеграций (оставлено для совместимости: его
 * понимает виджет и могут слушать страницы-хосты). Штатный скролл теперь идёт
 * командой виджета ниже, чтобы кастомные обработчики не уводили страницу мимо анкеты.
 */
export const SCROLL_TO_TOP_EVENT = 'testograf_SCROLL_TO_TOP';

/**
 * Команда виджета встраивания: подскроллить страницу-хост к контейнеру опроса
 * с учётом fixedHeaderHeight. Понимается всеми версиями embed.js (инлайн-встройка)
 * и widget.js (попап) — в т.ч. уже закреплёнными у клиентов.
 */
export const SCROLL_TO_SURVEY_COMMAND = 'scrollTop';

/** Скролл самого iframe (смена страницы, завершение). */
export const scrollToTop = (): void => {
    window.scrollTo(0, 0);
};

/**
 * Просим страницу-хост подскроллить к началу опроса командой виджета.
 */
export const notifyScrollToSurvey = (): void => {
    if (!isEmbedded) {
        return;
    }

    window.parent?.postMessage(SCROLL_TO_SURVEY_COMMAND, '*');
};

/**
 * Скролл наверх на значимых переходах (смена страницы/бандла, завершение):
 * внутри iframe и на странице-хосте. На первичном рендере вопросов хост не
 * трогаем — страница-хост не должна прыгать к опросу при загрузке.
 */
export const scrollSurveyToTop = (): void => {
    scrollToTop();
    notifyScrollToSurvey();
};

/**
 * Событие, которое survey шлёт родительской странице при встраивании через iframe
 * при смене страницы (бандла) опроса. Формат сообщения: `testograf_PAGE_CHANGED::<index>`,
 * где index — 0-based индекс текущего бандла.
 */
export const PAGE_CHANGED_EVENT = 'testograf_PAGE_CHANGED';

export const notifyPageChanged = (bundleIndex: number): void => {
    if (isEmbedded) {
        window.parent?.postMessage(`${PAGE_CHANGED_EVENT}::${bundleIndex}`, '*');
    }
};
